<template>
  <div class="container">
    <div @click="$emit('close')" class="close">❌</div>
    <div class="word-container">
      <div class="word">
        <CustomInput :input="inputList.twentyThree" />
        <CustomInput :input="inputList.thirteen" />
        <CustomInput :input="inputList.twentyTwo" />
        <CustomInput :input="inputList.seventeen" />
        <CustomInput :input="inputList.ten" />
        <CustomInput :input="inputList.twentySeven" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.seventeen" />
        <CustomInput :input="inputList.ten" />
        <CustomInput :input="inputList.sixteen" />
        <CustomInput :input="inputList.fourteen" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twentyTwo" />
        <CustomInput :input="inputList.thirteen" />
        <CustomInput :input="inputList.thirteen" />
        <CustomInput :input="inputList.four" />
        <CustomInput :input="inputList.seventeen" />
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.twentyOne" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twentyTwo" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.seven" />
        <CustomInput :input="inputList.twentyTwo" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twentyFive" />
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.thirteen" />
        <CustomInput :input="inputList.nine" />
        <CustomInput :input="inputList.four" />
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.thirteen" />
        <CustomInput :input="inputList.twentySix" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.fifteen" />
        <CustomInput :input="inputList.twentyTwo" />
        <CustomInput :input="inputList.eleven" />
        <CustomInput :input="inputList.twentySix" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twentyFive" />
        <CustomInput :input="inputList.twentySix" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.thirtyOne" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.nine" />
        <CustomInput :input="inputList.ten" />
        <CustomInput :input="inputList.fifteen" />
        <CustomInput :input="inputList.thirteen" />
        <CustomInput :input="inputList.twentySix" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.thirtyTwo" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.eleven" />
        <CustomInput :input="inputList.thirteen" />
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.sixteen" />
        <CustomInput :input="inputList.seventeen" />
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.twentyEight" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.thirtyThree" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twentyFive" />
        <CustomInput :input="inputList.twentySix" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.seven" />
        <CustomInput :input="inputList.twentyNine" />
        <CustomInput :input="inputList.twentyTwo" />
        <CustomInput :input="inputList.seven" />
        <CustomInput :input="inputList.twentyFour" />
        <CustomInput :input="inputList.three" />
        <CustomInput :input="inputList.four" />
        <CustomInput :input="inputList.eight" />
        <CustomInput :input="inputList.four" />
        <CustomInput :input="inputList.twentySix" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twentyTwo" />
        <CustomInput :input="inputList.sixteen" />
        <CustomInput :input="inputList.nineteen" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.thirtyFour" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.eleven" />
        <CustomInput :input="inputList.seven" />
        <CustomInput :input="inputList.twentyTwo" />
        <CustomInput :input="inputList.nine" />
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.fifteen" />
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.fourteen" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.four" />
        <CustomInput :input="inputList.seven" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.nine" />
        <CustomInput :input="inputList.twentyNine" />
        <CustomInput :input="inputList.twenty" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twentyTwo" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twelve" />
        <CustomInput :input="inputList.sixteen" />
        <CustomInput :input="inputList.twentyNine" />
        <CustomInput :input="inputList.sixteen" />
        <CustomInput :input="inputList.nine" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.eleven" />
        <CustomInput :input="inputList.twentyTwo" />
        <CustomInput :input="inputList.fourteen" />
        <CustomInput :input="inputList.thirty" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.fifteen" />
        <CustomInput :input="inputList.ten" />
        <CustomInput :input="inputList.sixteen" />
        <CustomInput :input="inputList.fifteen" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.fourteen" />
        <CustomInput :input="inputList.fifteen" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.thirtyFive" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twelve" />
        <CustomInput :input="inputList.sixteen" />
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.fourteen" />
        <CustomInput :input="inputList.fifteen" />
        <CustomInput :input="inputList.four" />
        <CustomInput :input="inputList.ten" />
        <CustomInput :input="inputList.nine" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twentyFive" />
        <CustomInput :input="inputList.twentySix" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.fourteen" />
        <CustomInput :input="inputList.twenty" />
        <CustomInput :input="inputList.eight" />
        <CustomInput :input="inputList.twentyThree" />
        <CustomInput :input="inputList.ten" />
        <CustomInput :input="inputList.seven" />
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.fourteen" />
        <CustomInput :input="inputList.twentyEight" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twentyFour" />
        <CustomInput :input="inputList.ten" />
        <CustomInput :input="inputList.nine" />
        <CustomInput :input="inputList.fifteen" />
        <CustomInput :input="inputList.thirteen" />
        <CustomInput :input="inputList.twentyTwo" />
        <CustomInput :input="inputList.four" />
        <CustomInput :input="inputList.thirteen" />
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.eight" />
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.nine" />
        <CustomInput :input="inputList.fifteen" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twentyTwo" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.thirtySix" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twentyFour" />
        <CustomInput :input="inputList.twentySix" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twelve" />
        <CustomInput :input="inputList.sixteen" />
        <CustomInput :input="inputList.twentySix" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twentyFive" />
        <CustomInput :input="inputList.four" />
        <CustomInput :input="inputList.fifteen" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.seven" />
        <CustomInput :input="inputList.twentyNine" />
        <CustomInput :input="inputList.twentyTwo" />
        <CustomInput :input="inputList.twentyFive" />
        <CustomInput :input="inputList.twentyTwo" />
        <CustomInput :input="inputList.two" />
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.thirty" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.seven" />
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.fourteen" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.twentyTwo" />
        <CustomInput :input="inputList.twentyThree" />
        <CustomInput :input="inputList.fourteen" />
        <CustomInput :input="inputList.twentySix" />
        <CustomInput :input="inputList.nine" />
        <CustomInput :input="inputList.fifteen" />
        <CustomInput :input="inputList.fourteen" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.nine" />
        <CustomInput :input="inputList.twentyNine" />
        <CustomInput :input="inputList.ten" />
        <CustomInput :input="inputList.nine" />
        <CustomInput :input="inputList.fifteen" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.eleven" />
        <CustomInput :input="inputList.twentyTwo" />
        <CustomInput :input="inputList.fourteen" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.fifteen" />
        <CustomInput :input="inputList.ten" />
        <CustomInput :input="inputList.sixteen" />
        <CustomInput :input="inputList.five" />
        <CustomInput :input="inputList.ten" />
        <CustomInput :input="inputList.sixteen" />
        <CustomInput :input="inputList.thirteen" />
        <CustomInput :input="inputList.fourteen" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.thirtySeven" />
      </div>
      <div class="word">
        <CustomInput :input="inputList.fifteen" />
        <CustomInput :input="inputList.ten" />
        <CustomInput :input="inputList.thirteen" />
        <CustomInput :input="inputList.fifteen" />
        <CustomInput :input="inputList.twentySeven" />

      </div>
    </div>
    <div class="button-wrapper">
      <p @click="$emit('next')">www.le-club-des-escape-game-parisien.com</p>
    </div>
  </div>
</template>

<script>
import CustomInput from "../shared/CustomInput";

export default {
  name: "Parchment",
  props: { inputList: Object },
  components: { CustomInput },
};
</script>

<style scoped>
.container {
  background: white;
  overflow: scroll;
  position: relative;
  padding: 5px 20px;
  background: #f1d68f;
}
.button-wrapper {
  font-family: "VT323", monospace;
  text-align: center;
  color: blue;
  font-size: 40px;
}
.button-wrapper:hover {
  opacity: 0.85;
  cursor: pointer;
}
.close {
  position: absolute;
  top: 5px;
  right: 5px;
}
.close:hover {
  cursor: pointer;
}
.word-container {
  display: flex;
  flex-wrap: wrap;
}
.word {
  display: flex;
  flex-wrap: nowrap;
  margin: 10px;
}
</style>
